export const getTimeFromString = (str: string | undefined) => {
  const arr = str?.split(':');
  if (arr && arr.length < 2) return ['00', '00'];
  return [arr?.at(0), arr?.at(1)];
};
